/*
 * Project: Dynamedics Portal Web
 * Created Date: Monday December 4th 2023
 * Author: KasunKarunasekara
 * -----
 * Last Modified: Monday December 4th 2023 6:38:00 pm
 * Modified By: KasunKarunasekara at <kkarunasekara@mitrai.com>
 * -----
 * Copyright (c) 2023 Mitra Sparks
 * -----
 * HISTORY:
 */

import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { cloneDeep } from 'lodash';
import { Link as RouterLink, useLocation, matchPath } from 'react-router-dom';
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, List, Drawer, Hidden, ListSubheader } from '@material-ui/core';
// hooks
import useAuth from '../../hooks/useAuth';
import { useDispatch, useSelector } from 'react-redux';
// components
// utils
import { checkUndefinedOrNull } from '../../utils/functions';
// slices
import { getPerspectiveList } from '../../redux/slices/report';
// routes
import { PATH_DASHBOARD } from '../../routes/paths';
import {
  ROLE_ADMIN_PORTAL_ACCESS,
  ROLE_INSIGHTS_SUPPLIER,
  ROLE_MANAGE_SUPPLIERS,
  ROLE_REPORT_READ
} from '../../utils/constants';
import { useTheme } from '@material-ui/core/styles';
import NavItems from './NavItems';
// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH
  }
}));

// ----------------------------------------------------------------------

MobileSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func
};

export default function MobileSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const theme = useTheme();
  const dispatch = useDispatch();

  const { bookmarkedViews, suppliersView } = useSelector(
    (state) => state.report
  );
  const [bookmarks, setBookmarks] = useState([]);
  const [supplierEventsView, setSupplierEventsView] = useState({});

  useEffect(() => {
    if (isOpenSidebar && onCloseSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps

    const bookmarks =
      bookmarkedViews.length > 0 &&
      bookmarkedViews.map((reportView) => {
        return {
          title: reportView.viewTitle,
          href: `${PATH_DASHBOARD.general.insightsBookmarksRoot}/${reportView.viewId}?view=${reportView.viewTitle}`,
          role: ROLE_REPORT_READ
        };
      });
    const supplierView = {
      title: suppliersView?.viewTitle,
      href:
        checkUndefinedOrNull(suppliersView) ||
        Object.keys(suppliersView).length === 0
          ? `${PATH_DASHBOARD.general.insightsSupplier}`
          : `${PATH_DASHBOARD.general.insightsSupplier}?viewId=${suppliersView.viewId}&view=${suppliersView.viewTitle}`,
      role: ROLE_INSIGHTS_SUPPLIER
    };

    setBookmarks(bookmarks);
    setSupplierEventsView(supplierView);
  }, [pathname, bookmarkedViews]);

  useEffect(() => {
    dispatch(getPerspectiveList());
  }, []);

  return (
    <RootStyle className={'sidebar'}>
      <Drawer
        open={isOpenSidebar}
        onClose={onCloseSidebar}
        PaperProps={{
          sx: {
            width: DRAWER_WIDTH,
            bgcolor: theme.palette.primary.main,
            color: theme.palette.common.white
          }
        }}
      >
        {<NavItems />}
      </Drawer>
    </RootStyle>
  );
}
